var _defs, _path, _g, _path2, _g2, _path3, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g13, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _line, _path50, _path51, _path52, _path53, _g14, _path54, _path55, _path56, _path57, _g15, _g16, _g17, _path58, _path59, _g18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParkingMeterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 283.209,
    height: 373.103,
    viewBox: "0 0 283.209 373.103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84979",
    "data-name": "Caminho 84979",
    d: "M237.739,171.391v262.1l-39.1-22.195V150.425Z",
    transform: "translate(-198.635 -150.425)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2.245,
    y1: 1.479,
    x2: -2.233,
    y2: 1.479,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25231f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#33302a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#46423a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4940"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84981",
    "data-name": "Caminho 84981",
    d: "M226.454,131.041l-2.751,3.008-39.1-23.384L169.156,66.859l.161.211Z",
    transform: "translate(-169.156 -66.859)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1.548,
    y1: 6.892,
    x2: -1.539,
    y2: 6.892,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25231f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4940"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84988",
    "data-name": "Caminho 84988",
    d: "M224.7.641,169.5,32.621a1.821,1.821,0,0,0-.9,1.851l.285.771.058.085,57.25,64.094a1.851,1.851,0,0,0,2.333.361l55.345-33.4a1.453,1.453,0,0,0,.419-2.171V64.2L227.011,1A1.851,1.851,0,0,0,224.7.641",
    transform: "translate(-168.58 -0.388)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.456,
    y1: 3.479,
    x2: -0.453,
    y2: 3.479,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8259",
    "data-name": "Ret\\xE2ngulo 8259",
    width: 59.733,
    height: 66.58,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8260",
    "data-name": "Ret\\xE2ngulo 8260",
    width: 116.038,
    height: 99.647,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8261",
    "data-name": "Ret\\xE2ngulo 8261",
    width: 59.634,
    height: 66.474,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8262",
    "data-name": "Ret\\xE2ngulo 8262",
    width: 59.49,
    height: 66.31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8263",
    "data-name": "Ret\\xE2ngulo 8263",
    width: 59.449,
    height: 66.279,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8264",
    "data-name": "Ret\\xE2ngulo 8264",
    width: 59.41,
    height: 66.217,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8265",
    "data-name": "Ret\\xE2ngulo 8265",
    width: 59.28,
    height: 66.092,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8266",
    "data-name": "Ret\\xE2ngulo 8266",
    width: 59.206,
    height: 65.988,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85009",
    "data-name": "Caminho 85009",
    d: "M330.629,173.034l-23.956,13.824a1.1,1.1,0,0,0-.563.968v9.163a.349.349,0,0,0,.048.174.34.34,0,0,0,.466.116l24.073-13.9a1.092,1.092,0,0,0,.561-.96v-9.036a.419.419,0,0,0-.629-.349",
    transform: "translate(-306.111 -172.977)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -6.381,
    y1: 16.7,
    x2: -6.36,
    y2: 16.7,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25231f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85023",
    "data-name": "Caminho 85023",
    d: "M294.632,321.3c-1.624.875-2.687,3.022-2.3,3.948a2.886,2.886,0,0,0,3.789,1.2A3.239,3.239,0,0,0,298,322.822a2.471,2.471,0,0,0-2.312-1.8,2.211,2.211,0,0,0-1.055.276",
    transform: "translate(-292.255 -321.023)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.662,
    cy: 0.51,
    r: 0.338,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b7e85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#777a81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#5b5d61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#434447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.361,
    stopColor: "#303133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#232424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85030",
    "data-name": "Caminho 85030",
    d: "M306.211,261.581l.01,7.952a.362.362,0,0,0,.53.32l28.306-15.18.1-8.984Z",
    transform: "translate(-306.211 -245.69)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -4.155,
    y1: 9.979,
    x2: -4.141,
    y2: 9.979,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#444038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#32302a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#282621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25231f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8274",
    "data-name": "Ret\\xE2ngulo 8274",
    width: 28.877,
    height: 17.253,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85033",
    "data-name": "Caminho 85033",
    d: "M334.432,212a.312.312,0,0,0-.113,0c-.014,0-.028.007-.049.007s-.014,0-.014.007c-.028.007-.056.014-.077.021s-.057.028-.063.035l-15.523,8.884-11.738,6.68a2.315,2.315,0,0,0-.73,1.352l-.014.261,28.87-15.657.007-1a.585.585,0,0,0-.556-.591",
    transform: "translate(-306.111 -211.992)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -4.712,
    y1: 13.782,
    x2: -4.697,
    y2: 13.782,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25231f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8276",
    "data-name": "Ret\\xE2ngulo 8276",
    width: 28.787,
    height: 16.6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85034",
    "data-name": "Caminho 85034",
    d: "M334.984,243.562v.8l-28.787,15.8.005-.944Z",
    transform: "translate(-306.197 -243.562)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -4.771,
    y1: 13.497,
    x2: -4.756,
    y2: 13.497,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8277",
    "data-name": "Ret\\xE2ngulo 8277",
    width: 1.083,
    height: 9.378,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85039",
    "data-name": "Caminho 85039",
    d: "M279.624,434.539l0,123.57,44.817-25.494V408.427Z",
    transform: "translate(-279.624 -408.427)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2.265,
    y1: 1.861,
    x2: -2.256,
    y2: 1.861,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25231f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2e2c27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#3f3c34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#49453d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4940"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8280",
    "data-name": "Ret\\xE2ngulo 8280",
    width: 0.242,
    height: 2.176,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8281",
    "data-name": "Ret\\xE2ngulo 8281",
    width: 8.586,
    height: 13.797,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8282",
    "data-name": "Ret\\xE2ngulo 8282",
    width: 11.802,
    height: 8.598,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8283",
    "data-name": "Ret\\xE2ngulo 8283",
    width: 3.218,
    height: 2.956,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8284",
    "data-name": "Ret\\xE2ngulo 8284",
    width: 9.373,
    height: 6.49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8285",
    "data-name": "Ret\\xE2ngulo 8285",
    width: 3.219,
    height: 3.063,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16791",
    "data-name": "Grupo 16791",
    transform: "translate(-27 -3094.262)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_8286",
    "data-name": "Ret\\xE2ngulo 8286",
    d: "M40.949,40.949V189.73h105.1V40.949H40.949M0,0H187V230.679H0Z",
    transform: "translate(27 3212.511)",
    fill: "#24cece"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16789",
    "data-name": "Grupo 16789",
    transform: "translate(-253.868 104.262)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16640",
    "data-name": "Grupo 16640",
    transform: "translate(463.61 3068.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16639",
    "data-name": "Grupo 16639",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8255",
    "data-name": "Ret\\xE2ngulo 8255",
    width: 45.066,
    height: 283.831,
    transform: "matrix(1, -0.021, 0.021, 1, -5.969, 0.126)",
    fill: "url(#linear-gradient)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84980",
    "data-name": "Caminho 84980",
    d: "M199.018,151.106l38.311,20.526V432.807l-38.311-21.736Zm-.4-.676V411.309l39.1,22.192V171.4Z",
    transform: "translate(264.983 2918.444)",
    fill: "#221f20"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16642",
    "data-name": "Grupo 16642",
    transform: "translate(448.153 3025.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16641",
    "data-name": "Grupo 16641",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8256",
    "data-name": "Ret\\xE2ngulo 8256",
    width: 57.298,
    height: 67.19,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84982",
    "data-name": "Caminho 84982",
    d: "M170.208,68.718,225.9,131.052l-2.284,2.5-38.7-23.138Zm-1.076-1.837,15.443,43.807,39.1,23.384,2.751-3.008L169.278,67.1l-.162-.21Z",
    transform: "translate(279.016 2958.186)",
    fill: "#221f20"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16644",
    "data-name": "Grupo 16644",
    transform: "translate(502.707 3056.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16749",
    "data-name": "Grupo 16749",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84983",
    "data-name": "Caminho 84983",
    d: "M316.309,139.857c-3.883,2.265-6.053,3.626-6.053,3.626l-30.9,17.882a11.142,11.142,0,0,1-5.741,1.134l-.41-.171,2.751-3.008a1.852,1.852,0,0,0,2.333.361l55.345-33.4-14.156,10.8s.7.5-3.175,2.779",
    transform: "translate(-273.207 -126.261)",
    fill: "#36332e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84984",
    "data-name": "Caminho 84984",
    d: "M327.475,130.439l-8.235,6.282a.4.4,0,0,0-.162.324.491.491,0,0,0,.03.162c-.079.161-.514.819-3.008,2.277-3.836,2.247-6.037,3.619-6.046,3.628L279.2,160.985a14.05,14.05,0,0,1-4.591,1.217,3.027,3.027,0,0,1-.694-.067L276,159.86a2.2,2.2,0,0,0,1.351.446,2.307,2.307,0,0,0,1.157-.315l48.975-29.552m6.16-4.188-55.345,33.4a1.934,1.934,0,0,1-.951.257,1.828,1.828,0,0,1-1.388-.618L273.2,162.3l.409.171a3.674,3.674,0,0,0,.988.125,13.87,13.87,0,0,0,4.714-1.191l30.931-17.948s2.171-1.361,6.046-3.626,3.182-2.791,3.182-2.791l14.156-10.8Z",
    transform: "translate(-273.203 -126.242)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84985",
    "data-name": "Caminho 84985",
    d: "M319.851,146.855s.694.514-3.172,2.79-6.053,3.626-6.053,3.626l-30.9,17.881a11.134,11.134,0,0,1-5.74,1.134,4.067,4.067,0,0,1,2.759,4.149l.209,133.683,44.805-26.087V150.34s.241-3.02-1.911-3.485m.409,136.518-40.532,23.809V175.94l39.7-22.912a.556.556,0,0,1,.834.482Z",
    transform: "translate(-273.576 -136.047)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84986",
    "data-name": "Caminho 84986",
    d: "M273.21,332.047h0l3.378.819-.019,123.685-3.36-2V194.679s.268.315.41.352a4.142,4.142,0,0,1,2.968,4.237v133.6Z",
    transform: "translate(-273.206 -158.796)",
    fill: "#25231f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84987",
    "data-name": "Caminho 84987",
    d: "M273.612,195.468a3.688,3.688,0,0,1,2.58,3.742V332.35l-2.58-.618Zm0,137.09,2.58.618-.018,122.658-2.562-1.513V332.56m-.4-137.881V332.047l3.378.819v-133.6a4.142,4.142,0,0,0-2.969-4.237c-.144-.039-.41-.352-.41-.352m0,137.368v122.5l3.367,1.883.012-123.569-3.378-.819Z",
    transform: "translate(-273.207 -158.796)",
    fill: "#221f20"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16646",
    "data-name": "Grupo 16646",
    transform: "translate(447.851 2990.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16645",
    "data-name": "Grupo 16645",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8258",
    "data-name": "Ret\\xE2ngulo 8258",
    width: 153.141,
    height: 150.378,
    transform: "translate(-48.607 38.15) rotate(-38.179)",
    fill: "url(#linear-gradient-3)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16672",
    "data-name": "Grupo 16672",
    transform: "translate(447.659 2990)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16750",
    "data-name": "Grupo 16750",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84989",
    "data-name": "Caminho 84989",
    d: "M227.4,100.057a2.056,2.056,0,0,1-1.534-.694l-57.25-64.094-.076-.114-.3-.81a2.021,2.021,0,0,1,.99-2.1L224.425.27a2.083,2.083,0,0,1,2.546.391l57.284,63.22a1.486,1.486,0,0,1,.351,1.257,1.755,1.755,0,0,1-.816,1.228L228.445,99.754a2.117,2.117,0,0,1-1.046.3M225.455.413a1.618,1.618,0,0,0-.828.231L169.434,32.615a1.64,1.64,0,0,0-.81,1.656l.315.792,57.229,64.045a1.641,1.641,0,0,0,2.083.315L283.6,66.034a1.37,1.37,0,0,0,.629-.926,1.124,1.124,0,0,0-.268-.925L226.69.973a1.669,1.669,0,0,0-1.236-.562Z",
    transform: "translate(-168.213 0)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16649",
    "data-name": "Grupo 16649",
    transform: "translate(7.667 28.601)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16648",
    "data-name": "Grupo 16648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16647",
    "data-name": "Grupo 16647",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84990",
    "data-name": "Caminho 84990",
    d: "M242.379,121.129a.191.191,0,0,1-.153-.067L182.894,54.886a.206.206,0,0,1,0-.284.2.2,0,0,1,.278.01l.007.008L242.513,120.8a.206.206,0,0,1,0,.284.231.231,0,0,1-.134.049",
    transform: "translate(-182.837 -54.549)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16652",
    "data-name": "Grupo 16652",
    transform: "translate(0.201 0.225)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16651",
    "data-name": "Grupo 16651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16650",
    "data-name": "Grupo 16650",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84991",
    "data-name": "Caminho 84991",
    d: "M225.637.816h0a1.445,1.445,0,0,1,1.078.477L284,64.5a.972.972,0,0,1,.21.761,1.2,1.2,0,0,1-.532.8L228.323,99.452a1.494,1.494,0,0,1-.742.208,1.423,1.423,0,0,1-1.074-.483L169.269,35.119V35.1l-.259-.694A1.438,1.438,0,0,1,169.725,33L224.917,1.029a1.375,1.375,0,0,1,.722-.2m0-.4a1.96,1.96,0,0,0-.925.247l-55.193,31.98a1.821,1.821,0,0,0-.9,1.851l.285.771.058.085,57.25,64.094a1.834,1.834,0,0,0,1.388.618,1.941,1.941,0,0,0,.953-.257l55.345-33.4a1.446,1.446,0,0,0,.419-2.17L227.037,1.05a1.837,1.837,0,0,0-1.372-.611Z",
    transform: "translate(-168.597 -0.43)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16655",
    "data-name": "Grupo 16655",
    transform: "translate(14.828 24.538)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16654",
    "data-name": "Grupo 16654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16653",
    "data-name": "Grupo 16653",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84992",
    "data-name": "Caminho 84992",
    d: "M255.933,113.274a.248.248,0,0,1-.153-.067L196.545,47.132a.2.2,0,1,1,.3-.266l59.235,66.066a.2.2,0,0,1-.013.278l-.008.007a.181.181,0,0,1-.123.058",
    transform: "translate(-196.494 -46.8)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16658",
    "data-name": "Grupo 16658",
    transform: "translate(21.939 20.417)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16657",
    "data-name": "Grupo 16657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16656",
    "data-name": "Grupo 16656",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84993",
    "data-name": "Caminho 84993",
    d: "M269.342,105.25a.179.179,0,0,1-.141-.067L210.093,39.261a.2.2,0,0,1,.305-.266l59.1,65.922a.2.2,0,0,1-.015.281l0,0a.229.229,0,0,1-.134.049",
    transform: "translate(-210.056 -38.94)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16661",
    "data-name": "Grupo 16661",
    transform: "translate(29.015 16.26)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16660",
    "data-name": "Grupo 16660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16659",
    "data-name": "Grupo 16659",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84994",
    "data-name": "Caminho 84994",
    d: "M282.807,97.29a.232.232,0,0,1-.153-.067L223.606,31.347a.212.212,0,0,1,0-.285.2.2,0,0,1,.284.016l0,0L282.95,96.946a.206.206,0,0,1-.018.287.192.192,0,0,1-.125.058",
    transform: "translate(-223.551 -31.011)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16664",
    "data-name": "Grupo 16664",
    transform: "translate(36.077 12.094)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16663",
    "data-name": "Grupo 16663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16662",
    "data-name": "Grupo 16662",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84995",
    "data-name": "Caminho 84995",
    d: "M296.229,89.283a.189.189,0,0,1-.153-.065l-59-65.809a.2.2,0,0,1,.013-.281l.006-.006a.211.211,0,0,1,.287,0l59,65.818a.206.206,0,0,1-.018.285.232.232,0,0,1-.134.058",
    transform: "translate(-237.021 -23.067)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16667",
    "data-name": "Grupo 16667",
    transform: "translate(43.205 7.982)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16666",
    "data-name": "Grupo 16666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16665",
    "data-name": "Grupo 16665",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84996",
    "data-name": "Caminho 84996",
    d: "M309.7,81.316a.187.187,0,0,1-.153-.067L250.666,15.556a.2.2,0,1,1,.3-.266l58.886,65.693a.206.206,0,0,1-.021.284.217.217,0,0,1-.129.049",
    transform: "translate(-250.616 -15.224)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16670",
    "data-name": "Grupo 16670",
    transform: "translate(50.336 3.908)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16669",
    "data-name": "Grupo 16669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16668",
    "data-name": "Grupo 16668",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84997",
    "data-name": "Caminho 84997",
    d: "M323.218,73.441a.233.233,0,0,1-.15-.067L264.267,7.8a.2.2,0,0,1,.014-.281l.007-.006a.185.185,0,0,1,.261-.014.118.118,0,0,1,.014.014l58.8,65.57a.211.211,0,0,1,0,.287.19.19,0,0,1-.148.069",
    transform: "translate(-264.216 -7.453)",
    fill: "gray"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84998",
    "data-name": "Caminho 84998",
    d: "M231,192.611l-11.107-6.285a4.8,4.8,0,0,0-7.159,4.179v16.861c0,9.522,6.761,18.356,15.04,23.069a6.147,6.147,0,0,0,9.189-5.35V202.817A13.022,13.022,0,0,0,231,192.611",
    transform: "translate(-189.391 -88.336)",
    fill: "#113b99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84999",
    "data-name": "Caminho 84999",
    d: "M233.7,208.812a5.593,5.593,0,0,1-1.351,4.466q-1.368,1.057-3.933-.391l-5.035-2.8v7.752l-3.142-1.773V194.684l8.531,4.769a9.863,9.863,0,0,1,4.931,9.36m-10.311-2.182,4.845,2.7q1.156.656,1.724.171c.379-.324.562-1.095.562-2.314a6.617,6.617,0,0,0-.516-2.791,3.745,3.745,0,0,0-1.608-1.715l-5.007-2.79Z",
    transform: "translate(-192.962 -92.607)",
    fill: "#f2f8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85000",
    "data-name": "Caminho 85000",
    d: "M231.613,239.3c2.13-1.382,5.847.568,8.3,4.354s2.718,7.974.587,9.355-5.847-.568-8.3-4.353-2.718-7.974-.587-9.356",
    transform: "translate(-197.686 -113.616)",
    fill: "#f3d638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85001",
    "data-name": "Caminho 85001",
    d: "M233.2,239.652h0a8.732,8.732,0,0,1,6.036,4.426,11.235,11.235,0,0,1,1.886,5.2,3.216,3.216,0,0,1-1.058,3.047,2.081,2.081,0,0,1-1.157.315,8.734,8.734,0,0,1-6.034-4.428,11.207,11.207,0,0,1-1.885-5.2,3.211,3.211,0,0,1,1.057-3.047,2.087,2.087,0,0,1,1.157-.316m0-.81a2.861,2.861,0,0,0-1.59.447c-2.133,1.388-1.865,5.569.59,9.357a9.315,9.315,0,0,0,6.71,4.8,2.874,2.874,0,0,0,1.592-.447c2.131-1.388,1.867-5.569-.59-9.36a9.329,9.329,0,0,0-6.71-4.8Z",
    transform: "translate(-197.688 -113.61)",
    fill: "#f3d638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85002",
    "data-name": "Caminho 85002",
    d: "M284.661,201.979l10.5,20.569-.852,79.246-9.748,31.418Z",
    transform: "translate(-223.556 -96.077)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85003",
    "data-name": "Caminho 85003",
    d: "M284.756,312.373l-.095-.028a.2.2,0,0,1-.1-.171V180.92a.2.2,0,0,1,.1-.18l40.523-23.384a.194.194,0,0,1,.2,0,.205.205,0,0,1,.1.171V288.353a.2.2,0,0,1-.1.18L284.86,312.347Zm.21-131.331v130.78l40.111-23.574V157.89Z",
    transform: "translate(-223.556 -74.837)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85004",
    "data-name": "Caminho 85004",
    d: "M360.391,263.981l.759,24.777V158.4l-.614,24.635Z",
    transform: "translate(-259.628 -75.347)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85005",
    "data-name": "Caminho 85005",
    d: "M294.012,376.941l30.94-16.837.5,24.621L284.627,408.5a.1.1,0,0,1-.142-.112Z",
    transform: "translate(-223.519 -171.294)",
    fill: "#3a3a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85006",
    "data-name": "Caminho 85006",
    d: "M314.434,391.952l19.342-10.493-.017,9.943-19.325,10.459Z",
    transform: "translate(-237.767 -181.452)",
    fill: "#464748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85007",
    "data-name": "Caminho 85007",
    d: "M315.054,392.255l18.692-10.138-.021,9.606L315.05,401.829Z",
    transform: "translate(-238.06 -181.765)",
    fill: "none",
    stroke: "#221f20",
    strokeWidth: 1.297
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85008",
    "data-name": "Caminho 85008",
    d: "M325.546,184.834v-26.5a.154.154,0,0,0-.231-.134l-40.078,23.133a.275.275,0,0,0-.109.36l10.182,20.483",
    transform: "translate(-223.814 -75.242)",
    fill: "#2d2c2c"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16674",
    "data-name": "Grupo 16674",
    transform: "translate(519.961 3080.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16673",
    "data-name": "Grupo 16673",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8268",
    "data-name": "Ret\\xE2ngulo 8268",
    width: 25.152,
    height: 24.398,
    transform: "translate(-0.003 0)",
    fill: "url(#linear-gradient-4)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16676",
    "data-name": "Grupo 16676",
    transform: "translate(512.078 3080.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16748",
    "data-name": "Grupo 16748",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85010",
    "data-name": "Caminho 85010",
    d: "M306.269,197.332a.534.534,0,0,1-.544-.54v-9.161a1.329,1.329,0,0,1,.66-1.154l23.955-13.815a.629.629,0,0,1,.943.533v9.036a1.315,1.315,0,0,1-.66,1.143l-24.083,13.9a.522.522,0,0,1-.271.057m24.382-24.354-.106.028L306.6,186.83a.9.9,0,0,0-.455.794v9.161a.127.127,0,0,0,.059.116.131.131,0,0,0,.134,0L330.418,183a.91.91,0,0,0,.455-.784v-9.036a.2.2,0,0,0-.113-.184Z",
    transform: "translate(-298.044 -172.579)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85011",
    "data-name": "Caminho 85011",
    d: "M306.441,204.207l.041,1.867L331.213,191.9v-.948Z",
    transform: "translate(-298.384 -181.32)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85012",
    "data-name": "Caminho 85012",
    d: "M317.031,226.7l.06.438c.028.2.387.282.65.146l2.218-1.152a.277.277,0,0,0,.181-.261l-.061-.44c-.028-.2-.387-.282-.65-.145l-2.217,1.154a.277.277,0,0,0-.181.261",
    transform: "translate(-303.421 -197.617)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85013",
    "data-name": "Caminho 85013",
    d: "M319.612,226.184l.2.227c.018.128.2.185.33.1l1.134-.564c.062-.038.057-.221.049-.282l-.038-.278c-.018-.127-.394-.163-.524-.081l-1.082.509c-.062.039-.074.307-.066.368",
    transform: "translate(-304.648 -197.64)",
    fill: "#8fb564"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85014",
    "data-name": "Caminho 85014",
    d: "M328.706,208.977l-.774,79.429a.561.561,0,0,1-.3.493L298.118,305.07a.33.33,0,0,1-.486-.3l.161-25.129a2.677,2.677,0,0,0-1.959-2.58,7.578,7.578,0,0,1-2.616-1.3c-2.232-1.8-2.492-7.646.76-11.172a11.012,11.012,0,0,1,2.167-1.8,3.738,3.738,0,0,0,1.775-3.113l.211-33.408a1.8,1.8,0,0,1,.915-1.562l28.814-16.22a.568.568,0,0,1,.845.493",
    transform: "translate(-291.295 -189.624)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85015",
    "data-name": "Caminho 85015",
    d: "M328.706,208.977l-.774,79.429a.561.561,0,0,1-.3.493L298.118,305.07a.33.33,0,0,1-.486-.3l.161-25.129a2.677,2.677,0,0,0-1.959-2.58,7.578,7.578,0,0,1-2.616-1.3c-2.232-1.8-2.492-7.646.76-11.172a11.012,11.012,0,0,1,2.167-1.8,3.738,3.738,0,0,0,1.775-3.113l.211-33.408a1.8,1.8,0,0,1,.915-1.562l28.814-16.22A.568.568,0,0,1,328.706,208.977Z",
    transform: "translate(-291.295 -189.624)",
    fill: "none",
    stroke: "#2d2d2d",
    strokeWidth: 1.343
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85016",
    "data-name": "Caminho 85016",
    d: "M336.517,330.764l11.355-6.354-.021,17.714-11.338,6.321Z",
    transform: "translate(-312.689 -244.802)",
    fill: "#2d2f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85017",
    "data-name": "Caminho 85017",
    d: "M337.156,288.747c-.728,1.246-1.931,1.888-2.7,1.436s-.813-1.8-.1-3.049,1.931-1.88,2.69-1.447.821,1.813.115,3.059",
    transform: "translate(-311.421 -226.317)",
    fill: "#f3d638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85018",
    "data-name": "Caminho 85018",
    d: "M336.781,288.577a5.277,5.277,0,0,1-1.013,1.386,2.339,2.339,0,0,1-.814.49,1.439,1.439,0,0,1-1.093-.094,1.559,1.559,0,0,1-.709-.867,2.556,2.556,0,0,1-.106-.991,4.207,4.207,0,0,1,.625-1.721,4.067,4.067,0,0,1,1.252-1.267,1.788,1.788,0,0,1,1.825-.167,1.643,1.643,0,0,1,.583,1.658,4.831,4.831,0,0,1-.55,1.573m-.071-.04a2.848,2.848,0,0,0,.438-1.544,1.407,1.407,0,0,0-.616-1.267,1.267,1.267,0,0,0-1.282.254,3.3,3.3,0,0,0-.961,1.145,3.1,3.1,0,0,0-.365,1.419,1.229,1.229,0,0,0,.378,1.042,1.305,1.305,0,0,0,1.211-.03,2.752,2.752,0,0,0,1.2-1.021Z",
    transform: "translate(-311.035 -226.136)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85019",
    "data-name": "Caminho 85019",
    d: "M303.323,323.191c-3.263,3.522-8.34,2.488-10.57.688s-2.486-7.645.767-11.17,8.753-4.531,11-2.728,2.06,9.686-1.193,13.21",
    transform: "translate(-291.076 -237.521)",
    fill: "#2d2f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85020",
    "data-name": "Caminho 85020",
    d: "M301.585,324.652a6.749,6.749,0,0,1-8.791.65c-1.853-1.491-1.352-6.122,1.348-9.037s6.63-3.392,8.5-1.9,1.647,7.372-1.052,10.287",
    transform: "translate(-291.368 -239.632)",
    fill: "#1d1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85021",
    "data-name": "Caminho 85021",
    d: "M301.585,324.652a6.749,6.749,0,0,1-8.791.65c-1.853-1.491-1.352-6.122,1.348-9.037s6.63-3.392,8.5-1.9S304.284,321.738,301.585,324.652Z",
    transform: "translate(-291.368 -239.632)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeWidth: 1.007
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85022",
    "data-name": "Caminho 85022",
    d: "M299.633,325.711a5.348,5.348,0,0,1-6.869.617c-1.549-1.173-1.017-3.929,1.186-6.157s5.253-3.089,6.813-1.913,1.074,5.226-1.13,7.453",
    transform: "translate(-291.457 -241.625)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16678",
    "data-name": "Grupo 16678",
    transform: "translate(512.697 3158.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16677",
    "data-name": "Grupo 16677",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8270",
    "data-name": "Ret\\xE2ngulo 8270",
    width: 8.786,
    height: 8.787,
    transform: "translate(-3.296 2.15) rotate(-35.748)",
    fill: "url(#radial-gradient)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16680",
    "data-name": "Grupo 16680",
    transform: "translate(516.567 3101.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16745",
    "data-name": "Grupo 16745",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_121",
    "data-name": "Linha 121",
    y2: 4.296,
    transform: "translate(0 57.887)",
    fill: "none",
    stroke: "#4d5151",
    strokeWidth: 0.671
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85024",
    "data-name": "Caminho 85024",
    d: "M339.774,364.767c-.271.464-.719.7-1.005.534s-.3-.668-.039-1.135.718-.7,1-.539.306.675.043,1.139",
    transform: "translate(-318.143 -284.098)",
    fill: "#65a7c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85025",
    "data-name": "Caminho 85025",
    d: "M340.4,364.538c-.136.233-.361.353-.5.268s-.152-.336-.019-.57.361-.352.5-.271.154.339.022.572",
    transform: "translate(-318.731 -284.271)",
    fill: "#aadff2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85026",
    "data-name": "Caminho 85026",
    d: "M339.632,364.7a2,2,0,0,1-.382.522.881.881,0,0,1-.307.184.542.542,0,0,1-.411-.035.589.589,0,0,1-.267-.327.955.955,0,0,1-.04-.373,1.58,1.58,0,0,1,.235-.648,1.529,1.529,0,0,1,.471-.478.673.673,0,0,1,.687-.063.618.618,0,0,1,.219.624,1.816,1.816,0,0,1-.207.592m-.027-.015a1.074,1.074,0,0,0,.165-.581.53.53,0,0,0-.232-.477.479.479,0,0,0-.483.1,1.245,1.245,0,0,0-.361.432,1.168,1.168,0,0,0-.138.534.465.465,0,0,0,.143.393.492.492,0,0,0,.456-.012,1.039,1.039,0,0,0,.45-.385Z",
    transform: "translate(-317.991 -284.02)",
    fill: "#221f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85027",
    "data-name": "Caminho 85027",
    d: "M336.517,330.764l11.355-6.354-.021,17.714-11.338,6.321Z",
    transform: "translate(-317.177 -265.467)",
    fill: "none",
    stroke: "#221f20",
    strokeWidth: 1.297
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85028",
    "data-name": "Caminho 85028",
    d: "M341.97,331.376l5.636-3.149-.009,12.845-5.628,3.138Z",
    transform: "translate(-319.773 -267.283)",
    fill: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_122",
    "data-name": "Linha 122",
    y1: 6.032,
    x2: 11.344,
    transform: "translate(19.335 73.426)",
    fill: "none",
    stroke: "#221f20",
    strokeWidth: 1.297
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85029",
    "data-name": "Caminho 85029",
    d: "M334.988,212.589l-.007,1.7-.042,16.445-28.011,15.115a.515.515,0,0,1-.753-.458l-.064-16.149.014-.261a1.955,1.955,0,0,1,.668-1.239,1.593,1.593,0,0,1,.3-.218l11.5-6.575,15.523-8.885a.618.618,0,0,0,.063-.035.445.445,0,0,1,.078-.021c0-.007.007-.007.014-.007s.035-.007.049-.007a.309.309,0,0,1,.112,0,.584.584,0,0,1,.556.591",
    transform: "translate(-302.716 -211.992)",
    fill: "#3f4351"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16682",
    "data-name": "Grupo 16682",
    transform: "translate(520.014 3118.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16681",
    "data-name": "Grupo 16681",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8272",
    "data-name": "Ret\\xE2ngulo 8272",
    width: 37.599,
    height: 37.681,
    transform: "matrix(0.698, -0.716, 0.716, 0.698, -12.141, 12.45)",
    fill: "url(#linear-gradient-5)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16697",
    "data-name": "Grupo 16697",
    transform: "translate(519.961 3101.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16746",
    "data-name": "Grupo 16746",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85031",
    "data-name": "Caminho 85031",
    d: "M347.017,282.392l-.878,1.855,1.776.445",
    transform: "translate(-325.152 -245.48)",
    fill: "none",
    stroke: "#f3d638",
    strokeLinecap: "round",
    strokeWidth: 0.523
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85032",
    "data-name": "Caminho 85032",
    d: "M326.046,296.067l.878-1.855-1.776-.445",
    transform: "translate(-315.166 -250.891)",
    fill: "none",
    stroke: "#f3d638",
    strokeLinecap: "round",
    strokeWidth: 0.523
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16687",
    "data-name": "Grupo 16687",
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16686",
    "data-name": "Grupo 16686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16685",
    "data-name": "Grupo 16685",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16684",
    "data-name": "Grupo 16684",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16683",
    "data-name": "Grupo 16683",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8273",
    "data-name": "Ret\\xE2ngulo 8273",
    width: 33.563,
    height: 28.488,
    transform: "matrix(0.891, -0.454, 0.454, 0.891, -6.982, 3.558)",
    fill: "url(#linear-gradient-6)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16692",
    "data-name": "Grupo 16692",
    transform: "translate(0.045 16.553)",
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16691",
    "data-name": "Grupo 16691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16690",
    "data-name": "Grupo 16690",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16689",
    "data-name": "Grupo 16689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16688",
    "data-name": "Grupo 16688",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8275",
    "data-name": "Ret\\xE2ngulo 8275",
    width: 33.186,
    height: 27.864,
    transform: "matrix(0.891, -0.454, 0.454, 0.891, -6.717, 3.424)",
    fill: "url(#linear-gradient-7)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85035",
    "data-name": "Caminho 85035",
    d: "M306.2,260.889l.008.407,28.782-15.8,0-.4Z",
    transform: "translate(-306.152 -227.736)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85036",
    "data-name": "Caminho 85036",
    d: "M355.427,326.164l1.083-.6V339.23l-.845.5Z",
    transform: "translate(-329.57 -266.018)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85037",
    "data-name": "Caminho 85037",
    d: "M315.711,408.677V407.7l17.961-9.925V399Z",
    transform: "translate(-310.678 -300.367)",
    fill: "#676868"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16695",
    "data-name": "Grupo 16695",
    transform: "translate(22.048 89.734)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16694",
    "data-name": "Grupo 16694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16693",
    "data-name": "Grupo 16693",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85038",
    "data-name": "Caminho 85038",
    d: "M348.161,383.731l1.083-.6v8.9l-.841.479Z",
    transform: "translate(-348.161 -383.135)",
    fill: "#1a1a1a"
  }))))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16699",
    "data-name": "Grupo 16699",
    transform: "translate(506.074 3204.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16698",
    "data-name": "Grupo 16698",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8279",
    "data-name": "Ret\\xE2ngulo 8279",
    width: 61.141,
    height: 153.728,
    transform: "translate(-16.493 1.84) rotate(-6.366)",
    fill: "url(#linear-gradient-8)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16719",
    "data-name": "Grupo 16719",
    transform: "translate(463.593 3080.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16747",
    "data-name": "Grupo 16747",
    transform: "translate(0 0)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85040",
    "data-name": "Caminho 85040",
    d: "M324.049,409.126V532.383l-44.01,25.145V434.766l44.017-25.64m.4-.694-44.822,26.114v123.56l44.822-25.485V408.431Z",
    transform: "translate(-237.147 -285.192)",
    fill: "#1a1a1a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85041",
    "data-name": "Caminho 85041",
    d: "M337.849,288.794a1.821,1.821,0,0,1-.339.955,1.743,1.743,0,0,1-.77.634.782.782,0,0,1-.742-.035.717.717,0,0,1-.273-.663,1.986,1.986,0,0,1,.569-1.2.147.147,0,0,1,.123-.056c.038.007.059.039.057.088a.223.223,0,0,1-.066.147,1.507,1.507,0,0,0-.431.912.517.517,0,0,0,.773.533,1.461,1.461,0,0,0,.846-1.212.528.528,0,0,0-.37-.594c-.038-.008-.058-.041-.057-.09a.229.229,0,0,1,.067-.151.141.141,0,0,1,.123-.055.7.7,0,0,1,.49.784m-.933.213.033-.837a.076.076,0,0,0-.116-.078.236.236,0,0,0-.127.187l-.035.832a.078.078,0,0,0,.117.081.229.229,0,0,0,.128-.185",
    transform: "translate(-263.828 -227.914)",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85042",
    "data-name": "Caminho 85042",
    d: "M324.436,645.073v9.676l-44.822,25.2v-9.274Z",
    transform: "translate(-237.139 -397.762)",
    fill: "gray"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85043",
    "data-name": "Caminho 85043",
    d: "M241.079,671.957v9.274L198.6,656.9v-9.135l39.1,22.273Z",
    transform: "translate(-198.603 -399.042)",
    fill: "gray"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85044",
    "data-name": "Caminho 85044",
    d: "M346.651,317.29l-9.759,5.279c-.385.209-.7-.046-.706-.568l-.037-4.241a1.554,1.554,0,0,1,.688-1.305l9.759-5.036c.385-.2.7.045.706.544l.036,4.049a1.551,1.551,0,0,1-.689,1.278",
    transform: "translate(-264.031 -239.017)",
    fill: "#373737"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85045",
    "data-name": "Caminho 85045",
    d: "M353.736,319.461l-1.151.616c-.284.152-.518-.027-.521-.4v-.019a1.137,1.137,0,0,1,.509-.946l1.151-.609c.285-.15.518.027.522.4v.018a1.141,1.141,0,0,1-.509.943",
    transform: "translate(-271.601 -242.204)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85046",
    "data-name": "Caminho 85046",
    d: "M353.736,319.461l-1.151.616c-.284.152-.518-.027-.521-.4v-.019a1.137,1.137,0,0,1,.509-.946l1.151-.609c.285-.15.518.027.522.4v.018A1.141,1.141,0,0,1,353.736,319.461Z",
    transform: "translate(-271.601 -242.204)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.095
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85047",
    "data-name": "Caminho 85047",
    d: "M348.4,318.523l.095-.868.164-.085-.095.867Z",
    transform: "translate(-269.86 -241.975)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85048",
    "data-name": "Caminho 85048",
    d: "M349.394,317.121a.336.336,0,0,0-.147.042.5.5,0,0,0-.274.412c0,.117.083.139.145.146s.086.02.086.056a.169.169,0,0,1-.1.131.258.258,0,0,1-.154.038l-.021,0-.021.194a.406.406,0,0,0,.182-.052.5.5,0,0,0,.282-.426.133.133,0,0,0-.139-.149c-.058-.008-.093-.015-.093-.053a.154.154,0,0,1,.093-.119.232.232,0,0,1,.123-.033l.015,0Z",
    transform: "translate(-270.101 -241.762)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85049",
    "data-name": "Caminho 85049",
    d: "M350.227,316.668l-.126.065a.159.159,0,0,0-.085.112l-.236.87.172-.09.033-.14.21-.109.02.111.152-.079Zm-.2.628.063-.261s.013-.054.021-.089l.012.064.04.214Z",
    transform: "translate(-270.514 -241.546)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85050",
    "data-name": "Caminho 85050",
    d: "M347.763,317.89l-.155.639-.018-.1a.3.3,0,0,0-.23-.224l.153.637.173-.091.25-.947Z",
    transform: "translate(-269.364 -242.085)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85051",
    "data-name": "Caminho 85051",
    d: "M347.3,318.268l-.264.137,0,.018a.323.323,0,0,1,.4.219l-.06-.344c-.01-.047-.039-.047-.075-.03",
    transform: "translate(-269.208 -242.303)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85052",
    "data-name": "Caminho 85052",
    d: "M348.193,322.072a1.458,1.458,0,0,1,.22-.75.383.383,0,0,0-.37.022,1.346,1.346,0,0,0-.586,1.12c0,.445.273.664.6.489a1.025,1.025,0,0,0,.366-.371.551.551,0,0,1-.231-.51",
    transform: "translate(-269.41 -243.742)",
    fill: "#e20d17"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85053",
    "data-name": "Caminho 85053",
    d: "M348.86,322.107a.551.551,0,0,0,.231.51,1.457,1.457,0,0,0,.22-.749.555.555,0,0,0-.231-.51,1.458,1.458,0,0,0-.22.75",
    transform: "translate(-270.077 -243.777)",
    fill: "#ea610a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85054",
    "data-name": "Caminho 85054",
    d: "M349.645,320.6a1.009,1.009,0,0,0-.366.368.555.555,0,0,1,.231.51,1.457,1.457,0,0,1-.22.75.383.383,0,0,0,.369-.024,1.347,1.347,0,0,0,.586-1.117c0-.442-.272-.66-.6-.487",
    transform: "translate(-270.276 -243.389)",
    fill: "#f59e00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85055",
    "data-name": "Caminho 85055",
    d: "M342.037,321.553c.018-.077.036-.153.055-.229s.032-.132.049-.2c.009-.034.018-.067.028-.1a.377.377,0,0,1,.029-.077.118.118,0,0,1,.038-.042.086.086,0,0,1,.038-.016c.014,0,.025.013.026.033s0,.032.005.048l0,.044c0,.016,0,.033.005.049s0,.031,0,.047,0,.031.006.047,0,.031,0,.047,0,.04.007.06,0,.032,0,.048,0,.031.005.047l0,.047c0,.015,0,.031.005.047l0,.045c0,.016,0,.032.005.048a.093.093,0,0,1-.02.063c-.02.022-.043.028-.059.015a.047.047,0,0,1-.01-.034c0-.02,0-.04-.006-.06s0-.042-.006-.063,0-.044-.007-.066,0-.043-.006-.064,0-.04-.007-.06,0-.032,0-.048,0-.041-.007-.062,0-.032,0-.048a.105.105,0,0,0,0-.02c-.007.025-.016.05-.022.076s-.019.076-.028.114-.018.077-.027.116c-.017.081-.035.162-.052.243,0,.016-.007.031-.012.047-.018.045-.054.071-.08.059a.044.044,0,0,1-.021-.031c-.013-.041-.024-.083-.037-.124-.023-.073-.047-.146-.071-.218-.009-.027-.021-.052-.031-.078l0-.006,0,.04c0,.024,0,.047-.006.071s0,.034,0,.05,0,.037,0,.055,0,.034,0,.05l0,.057c0,.019,0,.037,0,.056s0,.037,0,.056,0,.036,0,.054,0,.052-.006.079a.08.08,0,0,1-.022.044.061.061,0,0,1-.044.024c-.015,0-.024-.02-.021-.045l0-.055c0-.023,0-.045.006-.067s0-.043.005-.064,0-.045.006-.067,0-.034,0-.05,0-.046.006-.069,0-.045.005-.067,0-.044.006-.066,0-.034,0-.05,0-.046.006-.069,0-.034,0-.051a.1.1,0,0,1,.02-.062.081.081,0,0,1,.04-.028.085.085,0,0,1,.024-.006.047.047,0,0,1,.038.032,1.313,1.313,0,0,1,.067.164c.02.057.039.114.059.17Z",
    transform: "translate(-266.676 -243.555)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85056",
    "data-name": "Caminho 85056",
    d: "M343.4,320.776a.424.424,0,0,1,.045.03.123.123,0,0,1,.036.074.281.281,0,0,1,0,.068.34.34,0,0,1-.024.111.322.322,0,0,1-.138.176l-.242.127c-.022.012-.041,0-.043-.031l0-.042-.005-.6a.112.112,0,0,1,.02-.068.07.07,0,0,1,.022-.019l.2-.1a.112.112,0,0,1,.1-.009.122.122,0,0,1,.059.093.266.266,0,0,1,0,.109.384.384,0,0,1-.025.074Zm-.278.446.007,0,.2-.1a.138.138,0,0,0,.046-.046.183.183,0,0,0,.032-.107.066.066,0,0,0-.031-.062.072.072,0,0,0-.067.007l-.095.05a.029.029,0,0,1-.016,0c-.018,0-.027-.028-.02-.057a.088.088,0,0,1,.038-.06c.026-.013.051-.026.076-.042a.137.137,0,0,0,.05-.06.135.135,0,0,0,.008-.115.049.049,0,0,0-.072-.017l-.152.079-.007,0Z",
    transform: "translate(-267.306 -243.359)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85057",
    "data-name": "Caminho 85057",
    d: "M342.274,322.573c-.17.09-.341.179-.511.27-.049.027-.091,0-.1-.062a.441.441,0,0,1,0-.1.1.1,0,0,1,.044-.081c.024-.012.043.006.042.04v0c0,.014,0,.029,0,.042s.006.035.02.033l.006,0,.03-.016.963-.506a.046.046,0,0,0,.024-.027.078.078,0,0,0,0-.026.357.357,0,0,0,0-.037.1.1,0,0,1,.035-.089c.023-.018.046-.008.05.022v0a.449.449,0,0,1,0,.093.212.212,0,0,1-.1.17l-.512.27",
    transform: "translate(-266.653 -244.086)",
    fill: "#ce1821"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85058",
    "data-name": "Caminho 85058",
    d: "M342.358,319.914c.124-.065.249-.128.372-.194.052-.031.1-.009.113.053a.385.385,0,0,1,.013.092.1.1,0,0,1-.043.082c-.02.01-.038,0-.042-.026s0-.034-.007-.05-.021-.04-.042-.026h0l-.718.374a.09.09,0,0,0-.049.075v.012c0,.013,0,.026,0,.04a.092.092,0,0,1-.045.073c-.023.01-.041-.007-.041-.039a.5.5,0,0,1,.02-.138.2.2,0,0,1,.1-.132l.38-.2",
    transform: "translate(-266.749 -242.992)",
    fill: "#ce1821"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85059",
    "data-name": "Caminho 85059",
    d: "M344.508,320.226c0,.029-.009.058-.014.088-.012.071-.022.143-.038.214a.085.085,0,0,1-.023.049c-.015.017-.033.02-.045.008a.064.064,0,0,1-.011-.024c-.01-.044-.021-.089-.03-.135s-.02-.109-.03-.164c0-.023-.008-.046-.012-.069a.053.053,0,0,1,.016-.046l.007,0,.011,0c.009,0,.016.005.017.018.01.06.02.121.031.18s.017.094.026.142c0,0,0,.005,0,.006.012-.072.024-.145.036-.218.008-.052.016-.1.023-.156a.077.077,0,0,1,.029-.049c.017-.01.033,0,.034.021h0c0,.025.009.049.014.073s.014.074.021.111.017.075.025.113l0,0c.005-.036.011-.073.016-.11l.028-.2c0-.026.007-.051.01-.077a.049.049,0,0,1,.017-.034.025.025,0,0,1,.026-.007.032.032,0,0,1,.007.034c-.006.046-.012.091-.018.137s-.009.066-.014.1-.014.09-.021.135c0,.025-.009.05-.015.075a.076.076,0,0,1-.031.05.027.027,0,0,1-.037,0,.051.051,0,0,1-.008-.019l-.038-.169c-.006-.025-.01-.051-.016-.077Z",
    transform: "translate(-267.91 -243.11)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85060",
    "data-name": "Caminho 85060",
    d: "M345.317,320.088l-.052.027-.079.041a.013.013,0,0,0-.007.01h0l-.022.116a.056.056,0,0,1-.033.046h0c-.012,0-.017-.015-.013-.033h0c.011-.054.021-.109.033-.163q.028-.127.057-.253c0-.022.012-.044.018-.065a.055.055,0,0,1,.024-.035.041.041,0,0,1,.03-.011.015.015,0,0,1,.011.008c.009.021.017.044.025.067.017.051.033.1.049.154.01.033.019.067.029.1l.013.042a.054.054,0,0,1-.012.049h0c-.012.015-.027.015-.033,0l0-.005c-.009-.034-.019-.067-.03-.1m-.015-.061-.053-.167,0,0-.049.22Z",
    transform: "translate(-268.291 -243.021)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85061",
    "data-name": "Caminho 85061",
    d: "M345.772,319.7c.009-.03.019-.059.027-.087.016-.055.031-.111.046-.166.007-.021.024-.036.036-.032a.016.016,0,0,1,.011.009.055.055,0,0,1,0,.032l-.039.141a1.22,1.22,0,0,1-.044.133.039.039,0,0,1,0,.011.045.045,0,0,0-.006.03c0,.047,0,.093,0,.14a.053.053,0,0,1-.022.044l0,0c-.013.008-.024,0-.026-.014s0-.011,0-.017l0-.137a.018.018,0,0,0,0-.009.593.593,0,0,1-.062-.116c-.012-.028-.023-.057-.034-.086a.053.053,0,0,1,.013-.048l.009-.007c.019-.01.021,0,.029.015s.019.048.029.071.018.041.028.062l.016.031",
    transform: "translate(-268.548 -242.851)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85062",
    "data-name": "Caminho 85062",
    d: "M353.989,319.8l0,.262-.062.033-.006-.646.164-.087a.094.094,0,0,1,.106,0,.13.13,0,0,1,.046.112.322.322,0,0,1-.043.16.27.27,0,0,1-.106.112l-.1.054Zm0-.3,0,.225.1-.056a.149.149,0,0,0,.061-.065.2.2,0,0,0,.024-.092.08.08,0,0,0-.026-.065.051.051,0,0,0-.062,0l-.1.055Z",
    transform: "translate(-272.486 -242.818)",
    fill: "#383e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85063",
    "data-name": "Caminho 85063",
    d: "M354.707,319.4a.1.1,0,0,1,.109-.008.133.133,0,0,1,.041.113l0,.272-.059.032v-.061h0a.235.235,0,0,1-.1.13.088.088,0,0,1-.092.006.1.1,0,0,1-.038-.089.231.231,0,0,1,.038-.129.265.265,0,0,1,.1-.1.136.136,0,0,1,.091-.021v-.019a.066.066,0,0,0-.026-.06.057.057,0,0,0-.06,0,.189.189,0,0,0-.081.1l-.055-.017a.292.292,0,0,1,.132-.158m-.077.363a.044.044,0,0,0,.021.043.05.05,0,0,0,.048,0,.177.177,0,0,0,.069-.076.212.212,0,0,0,.03-.107.089.089,0,0,0-.081.012.172.172,0,0,0-.062.058.135.135,0,0,0-.025.074",
    transform: "translate(-272.791 -242.836)",
    fill: "#383e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85064",
    "data-name": "Caminho 85064",
    d: "M355.461,318.954l-.2.744-.063.034.074-.263-.139-.34.067-.036.1.264h0l.092-.367Z",
    transform: "translate(-273.061 -242.634)",
    fill: "#383e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85065",
    "data-name": "Caminho 85065",
    d: "M353.331,320.217l-.26.138,0,.143.149-.08a.326.326,0,0,1-.055.145l0,.087.092-.042a.645.645,0,0,0,.079-.316.478.478,0,0,0-.006-.075",
    transform: "translate(-272.08 -243.235)",
    fill: "#1787f2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85066",
    "data-name": "Caminho 85066",
    d: "M352.946,320.876h0a.261.261,0,0,1-.094.086.1.1,0,0,1-.156-.07l-.077.025-.014.12a.166.166,0,0,0,.249.072.471.471,0,0,0,.182-.187Z",
    transform: "translate(-271.859 -243.548)",
    fill: "#18a74f"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85067",
    "data-name": "Caminho 85067",
    d: "M352.658,320.635a.376.376,0,0,1,.008-.075l-.025-.083-.068.036a.616.616,0,0,0-.028.182.361.361,0,0,0,.031.151l.091-.144a.235.235,0,0,1-.009-.067",
    transform: "translate(-271.83 -243.358)",
    fill: "#fcb92c"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85068",
    "data-name": "Caminho 85068",
    d: "M352.844,319.879a.573.573,0,0,0-.245.336l.092.047a.359.359,0,0,1,.154-.235.1.1,0,0,1,.106,0l.078-.148a.168.168,0,0,0-.186,0",
    transform: "translate(-271.856 -243.06)",
    fill: "#fb423a"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85069",
    "data-name": "Caminho 85069",
    d: "M354.05,313.183l-1.747.907a.592.592,0,0,0-.08.048.259.259,0,0,0-.07.085.314.314,0,0,0-.035.114.865.865,0,0,0,0,.11l.012,1.321a.712.712,0,0,0,0,.106.116.116,0,0,0,.037.075.074.074,0,0,0,.071.012.465.465,0,0,0,.081-.037l1.747-.92a.474.474,0,0,0,.08-.047.265.265,0,0,0,.07-.085.334.334,0,0,0,.035-.113.867.867,0,0,0,0-.109l-.012-1.309a.87.87,0,0,0,0-.105.119.119,0,0,0-.037-.075.076.076,0,0,0-.071-.012.514.514,0,0,0-.08.036",
    transform: "translate(-271.625 -239.869)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85070",
    "data-name": "Caminho 85070",
    d: "M354.091,313.3a.423.423,0,0,1,.072-.034.052.052,0,0,1,.047.007.082.082,0,0,1,.024.05.709.709,0,0,1,0,.095l.012,1.309a.781.781,0,0,1,0,.1.208.208,0,0,1-.023.074.178.178,0,0,1-.046.056.485.485,0,0,1-.072.042l-1.747.92h0a.427.427,0,0,1-.072.034.05.05,0,0,1-.047-.007.076.076,0,0,1-.024-.05.7.7,0,0,1,0-.1l-.012-1.321a.434.434,0,0,1,.01-.138.205.205,0,0,1,.036-.067.273.273,0,0,1,.1-.066Z",
    transform: "translate(-271.666 -239.928)",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85071",
    "data-name": "Caminho 85071",
    d: "M353.158,315.62a.274.274,0,0,0,.026-.128.235.235,0,0,0-.078.095.258.258,0,0,0-.027.124.181.181,0,0,0,.078-.091",
    transform: "translate(-272.084 -240.987)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85072",
    "data-name": "Caminho 85072",
    d: "M352.994,315.81c-.044.019-.08.075-.1.086s-.052,0-.087.015a.264.264,0,0,0-.108.146.406.406,0,0,0,.036.34c.023.032.049.066.084.046s.046-.053.086-.074.052,0,.088-.018a.257.257,0,0,0,.08-.13.713.713,0,0,0,.035-.119s-.07,0-.072-.107a.293.293,0,0,1,.056-.165.075.075,0,0,0-.1-.02",
    transform: "translate(-271.892 -241.134)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85073",
    "data-name": "Caminho 85073",
    d: "M353.836,315.195c.094-.049.161,0,.163.131a.34.34,0,0,1-.161.3l-.1.055,0,.223-.076.04-.006-.654Zm-.1.4.086-.045a.2.2,0,0,0,.1-.184c0-.082-.038-.11-.1-.076l-.087.045Z",
    transform: "translate(-272.357 -240.837)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85074",
    "data-name": "Caminho 85074",
    d: "M354.354,315.608a.242.242,0,0,1,.131-.21l.1-.059V315.3c0-.052-.028-.07-.072-.047a.141.141,0,0,0-.074.109l-.069.036a.274.274,0,0,1,.145-.226c.086-.045.142-.013.143.082l0,.328-.07.037v-.078h0a.258.258,0,0,1-.112.145c-.069.037-.118,0-.119-.081m.229-.163v-.037l-.087.053a.126.126,0,0,0-.068.106c0,.041.026.055.066.035a.186.186,0,0,0,.09-.156",
    transform: "translate(-272.691 -240.827)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85075",
    "data-name": "Caminho 85075",
    d: "M355.023,315.51v-.079a.153.153,0,0,0,.024-.01.126.126,0,0,0,.062-.1l.006-.033-.133-.408.079-.041.093.34h0l.086-.433.077-.04-.128.568c-.029.131-.064.187-.137.226l-.03.013",
    transform: "translate(-272.989 -240.612)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85076",
    "data-name": "Caminho 85076",
    d: "M343.988,324.628a.3.3,0,0,1-.13.25l-1.963,1.057c-.073.039-.133-.01-.133-.111l-.016-1.752a.3.3,0,0,1,.13-.251l1.964-1.039c.072-.039.132.01.133.11Z",
    transform: "translate(-266.693 -244.448)",
    fill: "#3471c1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16702",
    "data-name": "Grupo 16702",
    transform: "translate(75.053 79.323)",
    opacity: 0.15,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16701",
    "data-name": "Grupo 16701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16700",
    "data-name": "Grupo 16700",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85077",
    "data-name": "Caminho 85077",
    d: "M341.855,326.683l-.015-1.751a.3.3,0,0,1,.13-.251l-.094.049a.3.3,0,0,0-.13.251l.016,1.752c0,.1.06.149.133.11l.093-.05c-.073.039-.132-.01-.133-.11",
    transform: "translate(-341.746 -324.681)",
    fill: "#202121"
  }))))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85078",
    "data-name": "Caminho 85078",
    d: "M342.376,326.07l.067-.036-.034-.1Z",
    transform: "translate(-266.993 -245.955)",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85079",
    "data-name": "Caminho 85079",
    d: "M343.057,326.515v.054l.112-.06v.058l-.112.06v.062l.124-.067.057-.118-.055-.058Z",
    transform: "translate(-267.317 -246.198)",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85080",
    "data-name": "Caminho 85080",
    d: "M344.683,324.724l-.035.135.069-.037Z",
    transform: "translate(-268.074 -245.378)",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85081",
    "data-name": "Caminho 85081",
    d: "M343.605,326.428l0-.237-.078.158Z",
    transform: "translate(-267.54 -246.076)",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85082",
    "data-name": "Caminho 85082",
    d: "M343.869,326.145c0-.023-.015-.029-.034-.019l-.063.034v.075l.067-.036a.058.058,0,0,0,.03-.053",
    transform: "translate(-267.657 -246.043)",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85083",
    "data-name": "Caminho 85083",
    d: "M344.284,325.954a.065.065,0,0,0,.009-.034c0-.018,0-.023-.009-.024a.056.056,0,0,0-.025.009l-.061.033,0,.066.06-.032a.094.094,0,0,0,.025-.017",
    transform: "translate(-267.86 -245.936)",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85084",
    "data-name": "Caminho 85084",
    d: "M343.7,324.2v.05l-.018-.04-.142.076v.049l-.018-.04-.194.1a.27.27,0,0,0-.084.07v-.025l-.136.072v.025a.059.059,0,0,0-.058.006l-.487.259-.032.122-.034-.086-.109.058-.045.024v.05l-.016-.042,0,0-.13.069-.059.227-.068.25v0h0l.154-.082h0v0l.017-.072.039-.021.019.057.176-.094v-.05l.015.042.088-.047.015-.058v.05l.07-.037.348-.186,0,0v-.108l.006,0c.006,0,.006,0,.006.009v.091l.218-.116v-.025a.133.133,0,0,0,.082-.019l.091-.048.018-.076.042-.023.019.057.175-.094v-.062l.028.048.006,0,0,0,.133-.071,0-.4Zm-1.022.894-.03.016-.018.01V325.1l0-.2,0,.012h0l-.068.256,0,0-.016.008-.026.014-.074-.19,0,.229-.1.055-.021-.051-.1.055-.021.074-.053.028.087-.339.076-.04.087.233,0-.278.018-.009.062-.033,0,0,.039.094.028.071v0l.059-.232.082-.044Zm.207-.34-.118.063v.054l.115-.061v.058l-.115.061v.058l.118-.063v.062l-.169.09,0-.294.169-.09Zm.216-.008h0l0,0a.066.066,0,0,1,.011.042v0h0v.065l-.045.024v-.033a.1.1,0,0,0-.009-.053l-.009,0s-.013,0-.028.01l-.054.029v.1l-.051.028,0-.291.115-.061c.027-.014.045-.024.06-.019s.024.019.025.051a.146.146,0,0,1-.036.1.023.023,0,0,1,.019.005m.1.067-.051.027,0-.29.051-.027Zm.59-.315-.067.036-.1-.168,0,.182h0v.038l-.051.027h0l-.052.028-.018-.052-.106.056-.018.076-.057.03c-.024.013-.055.021-.073.006s-.028-.044-.028-.1a.3.3,0,0,1,.026-.13.16.16,0,0,1,.076-.073l.048-.026v.062l-.048.026a.094.094,0,0,0-.039.038.172.172,0,0,0-.015.074c0,.033,0,.052.016.062s.021.005.037,0l.021-.012.068-.264.03-.016.045-.024.087.232v-.277l.075-.04.09.156,0-.2.051-.028Z",
    transform: "translate(-266.845 -245.097)",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85085",
    "data-name": "Caminho 85085",
    d: "M343.876,325.216l0-.006a.069.069,0,0,0,0-.034v0h0a.011.011,0,0,0-.009-.009.054.054,0,0,0-.024.009l-.061.032v.067l.061-.033a.079.079,0,0,0,.024-.017l0,0v0",
    transform: "translate(-267.664 -245.587)",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85086",
    "data-name": "Caminho 85086",
    d: "M344.358,325.2a.158.158,0,0,0-.016-.07l0-.186h0v-.013l-.146.078a.173.173,0,0,0-.041.047v-.025l-.139.074a.154.154,0,0,0-.06.057v-.025l-.248.132v.025c-.018-.011-.052,0-.067.01l-.163.087v.025c-.015-.013-.051,0-.07.012l-.181.1-.041.085-.04-.041-.013.007-.021.011-.239.127v.045l0,.374.266-.143.043-.083.038.04,0,0,.153-.082.007,0,0,0,0,0v-.1l.015-.008a.247.247,0,0,0,.069-.05v.112l.136-.073v-.107l.006,0c.009,0,.009,0,.009.007v.1l.411-.22a.184.184,0,0,0,.069-.062v.025l.13-.07a.2.2,0,0,0,.072-.059.26.26,0,0,0,.047-.137V325.2m-.953.484-.06.032v.108l-.1.053-.059-.06h0l0,0-.066.131-.193.1,0-.291.2-.1.054.052.012.011,0,0,.063-.129.16-.086c.031-.016.066-.025.08.012a.137.137,0,0,1,0,.027.15.15,0,0,1-.087.146m.3-.166a.1.1,0,0,1,.009.049v.058l-.051.027v-.037c0-.016,0-.046-.009-.053s-.018,0-.037.007l-.054.029v.107l-.051.028,0-.294.115-.061a.1.1,0,0,1,.06-.02c.015,0,.028.018.028.051a.148.148,0,0,1-.036.1c.015,0,.025,0,.028.01m.207-.232-.117.063v.054l.115-.061v.058l-.115.061v.058l.118-.063v.062l-.169.091,0-.294.169-.091Zm.13.164-.1.051v-.062l.1-.052a.04.04,0,0,0,.021-.019.065.065,0,0,0,.006-.024.024.024,0,0,0-.006-.017s-.009,0-.018,0c-.048.021-.106.057-.106-.035a.138.138,0,0,1,.072-.125l.1-.054v.07l-.093.05a.059.059,0,0,0-.021.015.036.036,0,0,0-.006.024c0,.012.006.013.012.014a.034.034,0,0,0,.018-.006l.027-.015c.027-.014.046-.016.058-.006a.072.072,0,0,1,.016.054.139.139,0,0,1-.078.133m.26-.168a.153.153,0,0,1-.063.063l-.1.052v-.062l.1-.052a.041.041,0,0,0,.022-.02.063.063,0,0,0,.006-.024.023.023,0,0,0-.006-.017s-.009,0-.018,0c-.048.022-.106.057-.106-.034a.146.146,0,0,1,.056-.116l.016-.01.1-.053v.07l-.067.036-.024.013,0,0a.072.072,0,0,0-.021.016.057.057,0,0,0-.006.024c0,.013,0,.015.012.014a.031.031,0,0,0,.018-.005l0,0,.024-.013a.079.079,0,0,1,.033-.01c.008,0,.036,0,.043.042v.014a.152.152,0,0,1-.018.072",
    transform: "translate(-267.228 -245.478)",
    fill: "#fff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Linha_123",
    "data-name": "Linha 123",
    x2: 0.04,
    y2: 4.593,
    transform: "translate(74.307 77.53)",
    fill: "none",
    stroke: "#f5d73d",
    strokeLinecap: "round",
    strokeWidth: 0.193
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85087",
    "data-name": "Caminho 85087",
    d: "M337.224,327c-.025-.02-.064,0-.088.048a.109.109,0,0,0,0,.121.11.11,0,0,1,0,.122c-.024.047-.023.1,0,.121s.063,0,.087-.046a.328.328,0,0,0,0-.367",
    transform: "translate(-264.492 -246.457)",
    fill: "#f5d73d"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85088",
    "data-name": "Caminho 85088",
    d: "M337.637,326.194c-.024-.021-.063,0-.088.045a.111.111,0,0,0,0,.123h0a.656.656,0,0,1,.006.732.11.11,0,0,0,0,.123c.024.021.063,0,.088-.045v0a.874.874,0,0,0-.008-.977",
    transform: "translate(-264.688 -246.074)",
    fill: "#f5d73d"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85089",
    "data-name": "Caminho 85089",
    d: "M338.294,326.059a.869.869,0,0,0-.243-.667c-.024-.022-.063,0-.088.044a.112.112,0,0,0,0,.123l0,0a1.2,1.2,0,0,1,.012,1.341.111.111,0,0,0,0,.123c.024.022.063,0,.088-.044l0,0a2.014,2.014,0,0,0,.23-.918",
    transform: "translate(-264.885 -245.692)",
    fill: "#f5d73d"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85090",
    "data-name": "Caminho 85090",
    d: "M338.484,326.784a1.958,1.958,0,0,0-.019-2.192c-.025-.02-.064,0-.088.048a.109.109,0,0,0,0,.12,1.74,1.74,0,0,1,.017,1.949.107.107,0,0,0,0,.121c.025.019.063,0,.086-.046",
    transform: "translate(-265.082 -245.312)",
    fill: "#f5d73d"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16705",
    "data-name": "Grupo 16705",
    transform: "translate(72.736)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16704",
    "data-name": "Grupo 16704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16703",
    "data-name": "Grupo 16703",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85091",
    "data-name": "Caminho 85091",
    d: "M337.327,178.157l8.253-4.733a.222.222,0,0,1,.333.188l-.008,8.99-8.578,4.589Z",
    transform: "translate(-337.327 -173.394)",
    fill: "#f4af40"
  }))))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85092",
    "data-name": "Caminho 85092",
    d: "M334.985,241.949,306.2,257.591v-2.049l28.783-15.372Z",
    transform: "translate(-249.785 -205.158)",
    fill: "#e7e7e7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85093",
    "data-name": "Caminho 85093",
    d: "M308.354,269.342l-2.142,1.15v-2.05l2.142-1.15Z",
    transform: "translate(-249.79 -218.06)",
    fill: "#b9b9ba"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85094",
    "data-name": "Caminho 85094",
    d: "M312.848,266.89l-2.142,1.174v-2.05l2.142-1.128Z",
    transform: "translate(-251.928 -216.915)",
    fill: "#b9b9ba"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85095",
    "data-name": "Caminho 85095",
    d: "M317.193,264.489l-2.142,1.179v-2.007l2.142-1.15Z",
    transform: "translate(-253.995 -215.785)",
    fill: "#b9b9ba"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16708",
    "data-name": "Grupo 16708",
    transform: "translate(64.584 34.321)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16707",
    "data-name": "Grupo 16707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16706",
    "data-name": "Grupo 16706",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85096",
    "data-name": "Caminho 85096",
    d: "M333.583,240.83l-11.8,6.619v-2.008l11.8-6.59Z",
    transform: "translate(-321.78 -238.851)",
    fill: "#e7e7e7"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16711",
    "data-name": "Grupo 16711",
    transform: "translate(64.005 36.074)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16710",
    "data-name": "Grupo 16710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16709",
    "data-name": "Grupo 16709",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85097",
    "data-name": "Caminho 85097",
    d: "M323.894,243.626l-2.627,1.474a.4.4,0,0,1-.591-.346v-.546a.4.4,0,0,1,.205-.348l3.013-1.665Z",
    transform: "translate(-320.676 -242.196)",
    fill: "#e7e7e7"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16714",
    "data-name": "Grupo 16714",
    transform: "translate(67.224 31.001)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16713",
    "data-name": "Grupo 16713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16712",
    "data-name": "Grupo 16712",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85098",
    "data-name": "Caminho 85098",
    d: "M335.907,233.938l-9.092,5.072v-1.459l9.016-5a.24.24,0,0,1,.357.21v.7a.546.546,0,0,1-.28.477",
    transform: "translate(-326.815 -232.519)",
    fill: "#565d72"
  }))))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85099",
    "data-name": "Caminho 85099",
    d: "M344.789,249.728l-2.142,1.179V248.9l2.142-1.15Z",
    transform: "translate(-267.122 -208.763)",
    fill: "#b9b9ba"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85100",
    "data-name": "Caminho 85100",
    d: "M354.739,242.56l-5.883,3.138v-1.84l5.883-3.141Z",
    transform: "translate(-270.075 -205.418)",
    fill: "#417158"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16717",
    "data-name": "Grupo 16717",
    transform: "translate(73.378 31.007)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16716",
    "data-name": "Grupo 16716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16715",
    "data-name": "Grupo 16715",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85101",
    "data-name": "Caminho 85101",
    d: "M341.589,233.889l-3.038,1.705v-1.458l2.847-1.572a.251.251,0,0,1,.372.219v.8a.355.355,0,0,1-.181.309",
    transform: "translate(-338.551 -232.531)",
    fill: "#e7e7e7"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingMeterLogo);
export default __webpack_public_path__ + "static/media/parking-meter-logo.fd1ee60d6d8a8630383e0456de69e00e.svg";
export { ForwardRef as ReactComponent };